// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WARNING: This section must be updated if _variables.ts is changed */
/* PERCENTAGE COLOURS */
:host {
  /* OR within a component's stylesheet using ::ng-deep */
}
:host .filter-label-text {
  font-size: 22px;
  font-weight: bold;
}
:host .filter-projects-title {
  color: #ffffff;
  font-size: 23px;
}
:host .imitate-angular-material {
  border-bottom: 1px solid #078BCB;
  margin-top: -7px;
}
:host .status-filter-label {
  font-size: 16px;
  font-weight: bold;
}
:host .cancel-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  color: #000000;
  opacity: 0.4;
  vertical-align: -4px;
}
:host ::ng-deep.ng-select.ng-select-focused:not(.ng-select-opened) > .ng-select-container,
:host .ng-select::ng-deep .ng-select-container {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
:host ::ng-deep.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input > input {
  min-height: 33px;
}
:host ::ng-deep.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value {
  background-color: transparent;
  border-radius: 20px;
  color: #ffffff;
  font-size: 14px;
  margin-right: 13px;
  padding: 5px 8px 5px 8px;
}
:host ::ng-deep.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon {
  border: none;
}
:host ::ng-deep.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon:hover {
  background-color: transparent;
}
:host ::ng-deep.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value:hover {
  background-color: rgba(35, 31, 32, 0.31);
}
:host ::ng-deep .mat-input-element::placeholder {
  color: white;
}
:host .mat-mdc-form-field::ng-deep,
:host .mat-mdc-form-field-flex::ng-deep {
  color: #ffffff;
}
:host .mat-mdc-form-field::ng-deep .mat-mdc-input-element,
:host .mat-mdc-form-field-flex::ng-deep .mat-mdc-input-element {
  color: #ffffff;
}
:host .mat-mdc-form-field::ng-deep.mat-date-range-input,
:host .mat-mdc-form-field-flex::ng-deep.mat-date-range-input {
  margin-top: 9px;
  margin-bottom: 9px;
}
:host .mat-mdc-form-field::ng-deep.mat-date-range-input .mat-input-element,
:host .mat-mdc-form-field-flex::ng-deep.mat-date-range-input .mat-input-element {
  margin-top: 0;
  margin-bottom: 0;
}
:host .mat-mdc-form-field::ng-deep .mat-datepicker-toggle,
:host .mat-mdc-form-field::ng-deep .mat-date-range-input-separator,
:host .mat-mdc-form-field-flex::ng-deep .mat-datepicker-toggle,
:host .mat-mdc-form-field-flex::ng-deep .mat-date-range-input-separator {
  color: #ffffff;
}
:host .mat-mdc-form-field::ng-deep .mat-datepicker-toggle button:focus,
:host .mat-mdc-form-field::ng-deep .mat-date-range-input-separator button:focus,
:host .mat-mdc-form-field-flex::ng-deep .mat-datepicker-toggle button:focus,
:host .mat-mdc-form-field-flex::ng-deep .mat-date-range-input-separator button:focus {
  outline: none;
}

.amount-column {
  width: 65%;
  margin-right: 50px;
}

.number-column {
  width: 25%;
}

.spacing-column {
  width: 10%;
}

.imitate-angular-material {
  border-bottom: 1px solid #067ab2;
}

::ng-deep.mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before,
::ng-deep.mdc-text-field--filled:not(.mdc-text-field--disabled):hover .mdc-line-ripple::before {
  border-bottom-color: #067ab2;
}

::ng-deep.mat-mdc-form-field-focus-overlay {
  background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/white-labelling/default/_variables.scss","webpack://./src/app/components/project-filter/project-filter.component.scss"],"names":[],"mappings":"AAiDA,sEAAA;AAYA,uBAAA;AC3DA;EA8DC,uDAAA;AA5DD;AADC;EACC,eAAA;EACA,iBAAA;AAGF;AAAC;EACC,cDgBM;ECfN,eAAA;AAEF;AACC;EACC,gCAAA;EACA,gBAAA;AACF;AAEC;EACC,eAAA;EACA,iBAAA;AAAF;AAGC;EACC,WAAA;EACA,YAAA;EACA,eAAA;EACA,cDnBM;ECoBN,YAAA;EACA,oBAAA;AADF;AAIC;;EAEC,6BAAA;EACA,YAAA;EACA,gBAAA;AAFF;AAOE;EACC,gBAAA;AALH;AAOE;EACC,6BAAA;EACA,mBAAA;EACA,cDtBK;ECuBL,eAAA;EACA,kBAAA;EACA,wBAAA;AALH;AAOG;EACC,YAAA;AALJ;AAOG;EACC,6BAAA;AALJ;AAQE;EACC,wCD3Cc;ACqCjB;AAWC;EACC,YAAA;AATF;AAYC;;EAEC,cD9CM;ACoCR;AAWE;;EAGC,cDlDK;ACwCR;AAYE;;EAIC,eAAA;EACA,kBAAA;AAZH;AAaG;;EACC,aAAA;EACA,gBAAA;AAVJ;AAaE;;;;EAEC,cDjEK;ACwDR;AAUG;;;;EACC,aAAA;AALJ;;AAWA;EACC,UAAA;EACA,kBAAA;AARD;;AAWA;EACC,UAAA;AARD;;AAWA;EACC,UAAA;AARD;;AAWA;EACC,gCAAA;AARD;;AAWA;;EAEC,4BDlHU;AC0GX;;AAWA;EACC,uBAAA;AARD","sourcesContent":["// Core theme colors\n$primary0: #0EABF7;\n$primary: #078BCB;\n$primary2: #067ab2;\n$primary3: #05699a;\n$selectedBackground: #ebf5ff;\n\n// Colour variables\n$black: #000000;\n$border-colour: #dee2e6;\n$card-border: #dfdfdf;\n$cardBorderGrey: #d9dee8;\n$disabled: #caced5;\n$disabledButtonColor: #7bb3d0;\n$disabled-background: #ececec;\n$form-error: #f84646;\n$highlight: #f5f5f5;\n$hoverHighlight: rgba(35, 31, 32, 0.31);\n$inactive: rgba(255, 0, 0, 0.1);\n$inactiveHighlight: rgba(255, 0, 0, 0.2);\n$kaliber-dark: #414448;\n$link: #2185d0;\n$placeholder: #aab2c0;\n$selectedButton: #002865;\n$subtitle: #a0a2a4;\n$white: #ffffff;\n$cardBorderGrey: #d9dee8;\n\n// Bootstrap Colours\n$secondary: #222222;\n$dark: #7a7a7a;\n$background-light: #efefef;\n$print-page-size: auto;\n\n$danger: #d9534f;\n$muted: #85959f;\n$text-muted: #85959f;\n$success: #61f2b6;\n$warning: #f0ad4e;\n$info: #5bc0de;\n$light: #f8f9fa;\n$light-gray: #d3d3d3;\n$background-dark: #414448;\n$disabled-background: rgba(221, 221, 221, 0.3) !default;\n\n// Common Styles\n$border: 1px solid $border-colour;\n$appComsHeight: 60px;\n\n/* WARNING: This section must be updated if _variables.ts is changed */\n$target: #fcb800;\n$declined: #d11f4b;\n$active: #f77f21;\n$quoteReady: #d299c4;\n$quoteApproved: #7c4795;\n$submitted: #662066;\n$won: #3e9937;\n$lost: #00245e;\n$live: #00b0f0;\n$completed: #a9d18e;\n\n/* PERCENTAGE COLOURS */\n$percentage-green: #15b422;\n$percentage-light-green: #a3d000;\n$percentage-yellow: #fcb000;\n$percentage-red: #ff0000;\n\n// DO NOT USE IF YOU SEE THESE BEING USED. PLEASE REMOVE\n$exportTableHeight: 530px;\n$footerHeight: 60px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n$headerHeight: 42px;\n$inputPercentWidth: 91px;\n$inputDiscountWidth: 126px;\n$exportTableHeight: 530px;\n$incExcTableHeight: 300px;\n$sidebarMenuWidth: 120px;\n$sideNavWidth: 67px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n\n// Image References\n$loginLogo: './assets';\n","@import 'variables';\n\n:host {\n\t.filter-label-text {\n\t\tfont-size: 22px;\n\t\tfont-weight: bold;\n\t}\n\n\t.filter-projects-title {\n\t\tcolor: $white;\n\t\tfont-size: 23px;\n\t}\n\n\t.imitate-angular-material {\n\t\tborder-bottom: 1px solid $primary;\n\t\tmargin-top: -7px;\n\t}\n\n\t.status-filter-label {\n\t\tfont-size: 16px;\n\t\tfont-weight: bold;\n\t}\n\n\t.cancel-icon {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tfont-size: 18px;\n\t\tcolor: $black;\n\t\topacity: 0.4;\n\t\tvertical-align: -4px;\n\t}\n\n\t::ng-deep.ng-select.ng-select-focused:not(.ng-select-opened) > .ng-select-container,\n\t.ng-select::ng-deep .ng-select-container {\n\t\tbackground-color: transparent;\n\t\tborder: none;\n\t\tbox-shadow: none;\n\t}\n\n\t::ng-deep.ng-select.ng-select-multiple .ng-select-container .ng-value-container {\n\t\t// Prevent input from becoming smaller when no statuses are selected\n\t\t.ng-input > input {\n\t\t\tmin-height: 33px;\n\t\t}\n\t\t.ng-value {\n\t\t\tbackground-color: transparent;\n\t\t\tborder-radius: 20px;\n\t\t\tcolor: $white;\n\t\t\tfont-size: 14px;\n\t\t\tmargin-right: 13px;\n\t\t\tpadding: 5px 8px 5px 8px;\n\n\t\t\t.ng-value-icon {\n\t\t\t\tborder: none;\n\t\t\t}\n\t\t\t.ng-value-icon:hover {\n\t\t\t\tbackground-color: transparent;\n\t\t\t}\n\t\t}\n\t\t.ng-value:hover {\n\t\t\tbackground-color: $hoverHighlight;\n\t\t}\n\t}\n\n\t/* OR within a component's stylesheet using ::ng-deep */\n\t::ng-deep .mat-input-element::placeholder {\n\t\tcolor: white;\n\t}\n\n\t.mat-mdc-form-field::ng-deep,\n\t.mat-mdc-form-field-flex::ng-deep {\n\t\tcolor: $white;\n\t\t.mat-mdc-input-element {\n\t\t\t//margin-top: 9px;\n\t\t\t//margin-bottom: 9px;\n\t\t\tcolor: $white;\n\t\t}\n\t\t&.mat-date-range-input {\n\t\t\t// The mat-input-element style above normally applies the margin\n\t\t\t// on the input element, but we want it on the parent element for\n\t\t\t// date-range-pickers as they contain 2 matInputs (to prevent 2x the margin).\n\t\t\tmargin-top: 9px;\n\t\t\tmargin-bottom: 9px;\n\t\t\t.mat-input-element {\n\t\t\t\tmargin-top: 0;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\t\t.mat-datepicker-toggle,\n\t\t.mat-date-range-input-separator {\n\t\t\tcolor: $white;\n\t\t\tbutton:focus {\n\t\t\t\toutline: none;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.amount-column {\n\twidth: 65%;\n\tmargin-right: 50px;\n}\n\n.number-column {\n\twidth: 25%;\n}\n\n.spacing-column {\n\twidth: 10%;\n}\n\n.imitate-angular-material {\n\tborder-bottom: 1px solid $primary2;\n}\n\n::ng-deep.mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before,\n::ng-deep.mdc-text-field--filled:not(.mdc-text-field--disabled):hover .mdc-line-ripple::before {\n\tborder-bottom-color: $primary2;\n}\n\n::ng-deep.mat-mdc-form-field-focus-overlay {\n\tbackground: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
